import { lazy, PropsWithChildren, Suspense } from 'react'

import { AppLoader } from '@/modules/components/AppLoader.tsx'

const German = lazy(() => import('./locales/de.tsx'))

// For now, we only have a single locale
export const LanguageProvider = ({ children }: PropsWithChildren) => {
  return (
    <Suspense fallback={<AppLoader />}>
      <German>{children}</German>
    </Suspense>
  )
}
